/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var dateRangePickerPanelProps = {
  defaultTime: {
    type: Array,
    "default": function _default() {
      return ["00:00:00", "23:59:59"];
    }
  },
  onCellClick: Function,
  onChange: Function,
  onConfirm: Function,
  onMonthChange: Function,
  onPanelClick: Function,
  onPresetClick: Function,
  onTimeChange: Function,
  onYearChange: Function
};

export { dateRangePickerPanelProps as default };
//# sourceMappingURL=date-range-picker-panel-props.mjs.map
